<template>
  <div class="range-input" :class="{ disabled: disabled }">
    <div class="range-input__label">
      {{ label }}
    </div>
    <div class="range-input__container">
      <input
        ref="fill"
        type="range"
        :min="min"
        :max="max"
        :value="value"
        :step="step"
        :disabled="disabled"
        :style="`background-size: ${((value - min) * 100) / (max - min)}% 100%`"
        @input="event => handleChange(event)"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
    step: {
      type: Number,
      default: 1,
    },
    value: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleFill(value = this.value) {
      const fill = this.$refs['fill']
      fill.style.setProperty(
        'background-size',
        `${((value - this.min) * 100) / (this.max - this.min)}% 100%`
      )
    },
    handleChange(e) {
      this.handleFill(e.target.value)
      this.$emit('on-input', e.target.value)
    },
  },
  mounted() {
    this.handleFill()
  },
}
</script>

<style lang="scss" scoped>
@import './rangeInput.scss';
</style>
